import { useTranslation } from 'react-i18next';
import { NoSymbolIcon } from '@heroicons/react/24/outline';
import { Loading } from 'react-daisyui';
import { tBlockedContactBannerProps } from './BlockedContactBanner.types';
import './BlockedContactBanner.styles.scss';

/**
 * Composer replacement shown when the WAPI contact of the open chat is
 * blocked on WhatsApp (INT-1294). Meta never delivers messages to a blocked
 * user, so instead of letting the send fail with a generic delivery error the
 * whole composer (input, toolbar, attachments, templates, send) is unmounted
 * — mirroring the WhatsAppWebReadOnlyBanner pattern — and this banner states
 * why the chat box is disabled, with unblocking one click away.
 */
export default function BlockedContactBanner(
  props: tBlockedContactBannerProps,
) {
  const { loading, onUnblock } = props;
  const { t } = useTranslation('chat/chat');

  return (
    <div className="BlockedContactBanner" role="status">
      <NoSymbolIcon className="BlockedContactBanner__Icon" />
      <p className="BlockedContactBanner__Text">
        {t('blockedContactBanner.message')}
      </p>
      <button
        type="button"
        onClick={onUnblock}
        disabled={loading}
        className="BlockedContactBanner__UnblockButton"
      >
        {loading ? (
          <Loading size="xs" />
        ) : (
          t('blockedContactBanner.unblockButton')
        )}
      </button>
    </div>
  );
}
